export default "__VITE_ASSET__2p5$50UT__"